<header
  class="bg-gray-100 border-b-2 hidden xl:block relative z-30"
  role="banner"
>
  <div class="p-2">
    <nav
      class="flex gap-2 items-center"
      role="navigation"
      aria-label="Navegación principal"
    >
      <!-- Menú hamburguesa -->
      <ng-template #menuButton>
        <button
          (click)="onToggleSidebar()"
          class="flex gap-2 items-center p-3 text-gray-700 transition-colors h-12 hover:text-allasRed"
          aria-label="Abrir menú de navegación"
          type="button"
        >
          <img
            src="/allas-icons/hamburger_icon.svg"
            alt="Icono de menú"
            class="w-auto h-4"
            width="16"
            height="16"
            loading="eager"
          />
          <span class="text-sm font-light fs-condensed">Menú</span>
        </button>
      </ng-template>

      <!-- Separador visual -->
      <ng-template #separator>
        <div
          class="w-px h-6 bg-gray-300 mx-1 lg:mx-2 flex-shrink-0"
          role="separator"
          aria-hidden="true"
        ></div>
      </ng-template>

      <!-- Contenido principal del header -->
      <ng-container>
        <ng-container *ngTemplateOutlet="menuButton"></ng-container>
        <ng-container *ngTemplateOutlet="separator"></ng-container>

        <!-- Selector de vehículo -->
        <allas-garage-dropdown whichShow="vehicle"></allas-garage-dropdown>

        <!-- Barra de búsqueda -->
        <div class="flex-auto">
          <allas-search-bar></allas-search-bar>
        </div>

        <!-- Selector de tienda -->
        <allas-garage-dropdown whichShow="store"></allas-garage-dropdown>

        <ng-container *ngTemplateOutlet="separator"></ng-container>

        <!-- Carrito de compras -->
        <allas-cart-mini></allas-cart-mini>
      </ng-container>
    </nav>
  </div>
</header>
